import React from "react";
import "./Hero.css";
import { useTranslation } from "react-i18next";

function Hero() {
	const { t } = useTranslation();

	return (
		<section className="hero">
			<div className="hero-image">
			</div>
			<div className="hero-content">
				<h2>{t("heroTitle")}</h2>
				<p>{t("heroText")}</p>
				{/* 				
				<button className="hero-button">Learn More</button> */}
			</div>
		</section>
	);
}

export default Hero;
